import LzMBase, { LzNBase } from "./Base";

export interface LzNGeneric extends LzNBase {
}

class LzMGeneric extends LzMBase implements LzNGeneric {

    constructor(model?: LzNGeneric, copyAll?: boolean) {
        super(model, copyAll);
    }

}

export default LzMGeneric;
